const normalizeFullscreenBanner = (bannerFromAdfox) => ({
    ...bannerFromAdfox,
    data: {
        ...bannerFromAdfox.data,
        scripts: bannerFromAdfox.data.content2,
        html: bannerFromAdfox.data.content3,
    },
});

export { normalizeFullscreenBanner };
//# sourceMappingURL=normalizeFullscreenBanner.js.map
